/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { FC } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import { Helmet } from "react-helmet"
import Footer from "./footer"

const Layout: FC = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      {/* siteTitle={data.site.siteMetadata.title} */}
      <Header />
      <>{children}</>
      <Footer />
    </>
  )
}

export default Layout
